import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const UploadedFileIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M7 4C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V10H15C13.3431 10 12 8.65685 12 7V4H7ZM7 2C5.34315 2 4 3.34315 4 5V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V8.41421C20 7.88378 19.7893 7.37507 19.4142 7L15 2.58579C14.6249 2.21071 14.1162 2 13.5858 2H7ZM14 4.41421V7C14 7.55228 14.4477 8 15 8H17.5858L14 4.41421ZM10.4453 9.66795C10.9048 9.3616 11.5257 9.48577 11.8321 9.9453C12.8157 11.4208 12.9709 12.6786 12.9954 13.5544C13.5636 14.0326 14.6129 14.7475 15.7425 15.0299C16.2783 15.1638 16.6041 15.7067 16.4701 16.2425C16.3362 16.7783 15.7933 17.1041 15.2575 16.9701C14.0971 16.68 13.0497 16.0826 12.2907 15.5368C12.0677 15.7978 11.8081 16.0539 11.5467 16.2908C10.8748 16.9 10.0825 17.4802 9.5547 17.8321C9.09517 18.1384 8.4743 18.0142 8.16795 17.5547C7.8616 17.0952 7.98577 16.4743 8.4453 16.1679C8.91746 15.8532 9.62523 15.3333 10.2033 14.8092C10.4943 14.5453 10.7257 14.3044 10.8764 14.1066C10.9502 14.0096 10.9849 13.9486 11 13.9198C10.9991 13.1946 10.9724 12.2614 10.1679 11.0547C9.8616 10.5952 9.98577 9.9743 10.4453 9.66795Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

UploadedFileIcon.propTypes = {
  ...sizePropsTypes,
};

export default UploadedFileIcon;
